// GitHub repository invitations of an order: status per repository and one-click resend.
import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/apiEndpoints';
import { getErrorMessage } from '../utils/apiError';

/**
 * Invitation statuses (Modules/Fulfillment/GitHubInvites.cs): Pending | Accepted | Expired | Declined | Failed |
 * Removed | Unknown. Each item: { repository, productName, gitHubUsername, status, invitedAt, expiresAt, acceptedAt,
 * lastCheckedAt, lastSentAt, sendCount, error, acceptUrl, repositoryUrl, canResend, nextResendAt }
 */
const githubInviteService = {
  /** GET /api/github-invites/order/{orderId}?refresh — refresh re-checks GitHub when the saved status is stale. */
  getInvites: async (orderId, { refresh = true } = {}) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.GITHUB_INVITES.ORDER(orderId), { params: { refresh } });
      return { success: true, data: response.data?.data || [] };
    } catch (error) {
      return { success: false, error: getErrorMessage(error, "Couldn't check your GitHub invitations") };
    }
  },

  /**
   * Sends a fresh invitation (any pending one is cancelled). Omit repository to resend every one not yet accepted.
   * Failed responses still carry the current invitations in data.
   */
  resend: async (orderId, repository) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.GITHUB_INVITES.RESEND(orderId), repository ? { repository } : {});
      return { success: true, data: response.data?.data || [], message: response.data?.message };
    } catch (error) {
      return {
        success: false,
        data: error?.response?.data?.data,
        error: getErrorMessage(error, "Couldn't send a new invitation"),
      };
    }
  },
};

export default githubInviteService;
